<template>
  <div>
    <v-card>
      <!-- search -->
      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <div class="d-flex align-center pb-5">
          <h1>Data</h1>
        </div>
        <v-spacer></v-spacer>
        <!-- create new -->
        <v-btn color="primary" class="me-3" @click="run">
          <v-icon size="18" class="me-1">
            {{ icons.mdiPlayCircle }}
          </v-icon>
          <span>Ejecutar</span>
        </v-btn>

        <v-btn
        :disabled="jsonData.length == 0"
         color="primary" class="me-3" @click="downloadCSV">
          <v-icon size="18" class="me-1">
            {{ icons.mdiDownloadMultiple  }}
          </v-icon>
        </v-btn>
      </v-card-text>
      <v-card-text>
        <aceEditor
          v-model="code"
          lang="sql"
          theme="monokai"
          width="100%"
          height="250px"
          :options="{
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            fontSize: 14,
            highlightActiveLine: true,
            enableSnippets: true,
            showLineNumbers: true,
            tabSize: 2,
            showPrintMargin: false,
            showGutter: true,
          }"
          @init="
            () => {
              require('brace/ext/language_tools') // language extension prerequsite...
              require('brace/mode/sql') // languagen
              require('brace/theme/monokai') // theme
              require('brace/snippets/sql') // snippet
            }
          "
        />
      </v-card-text>
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th v-for="(value, key) in jsonData[0]" :key="key">
                  {{ key }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in jsonData" :key="index">
                <td v-for="(value, key) in item" :key="key">
                  {{ value }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mdiPlayCircle, mdiDownloadMultiple  } from '@mdi/js'

// composition function
import { ref } from '@vue/composition-api'
import aceEditor from 'vuejs-ace-editor'
import store from '@/store'
import Papa from "papaparse";

export default {
  components: {
    aceEditor,
  },
  setup() {
    const code = ref('')
    const jsonData = ref([])

    const validateQuery = userQuery => {
      const invalidCommandsPattern = /\b(INSERT|UPDATE|DELETE|CREATE|ALTER|DROP|TRUNCATE)\b/i

      if (invalidCommandsPattern.test(userQuery)) {
        throw new Error('La consulta contiene comandos SQL no permitidos.')
      }

      const selectPattern = /^SELECT\b/i
      if (!selectPattern.test(userQuery)) {
        throw new Error('La consulta debe comenzar con la instrucción SELECT.')
      }

      const wherePattern = /\bWHERE\b/i
      if (!wherePattern.test(userQuery)) {
        throw new Error('La consulta debe incluir la cláusula WHERE.')
      }
    }

    const run = () => {
      jsonData.value = []
      validateQuery(code.value)
      store.dispatch('data/apiCall', { mode: 'insert', request: { query: code.value } }).then(result => {
        if (result.success) {
          jsonData.value = result.data
        }
      })
    }

    const downloadCSV = () => {
      const csvData = Papa.unparse(jsonData.value);
      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", "data.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    return {
      code,
      run,
      jsonData,
      downloadCSV,
      icons: {
        mdiPlayCircle,
        mdiDownloadMultiple 
      },
    }
  },
}
</script>
